import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFeedbackInvitation } from './FeedbackInvitationContext';
import { FEEDBACK_PATH, useOnFeedbackScreen } from './feedbackScreen';
import './FeedbackInvitationBanner.css';

// Invites an engaged user to say what the product is worth to them (#212).
//
// A banner rather than a modal or a toast on purpose: it must neither block the lesson the user
// is in the middle of, nor vanish before they have noticed it. It offers the existing feedback
// screen and a way out, and nothing else.
function FeedbackInvitationBanner() {
  const { t } = useTranslation();
  const { invited, dismiss } = useFeedbackInvitation();
  // Standing on a screen that already makes the offer, the banner is noise: it would point at the
  // page the user is already reading, and it would sit on top of the explanation owed to someone
  // the spent-allowance funnel (#208) sent here without asking.
  const onFeedbackScreen = useOnFeedbackScreen();

  if (!invited || onFeedbackScreen) {
    return null;
  }

  return (
    <div className="feedback-invitation-banner" role="status">
      <span className="feedback-invitation-banner__message">{t('feedbackInvitation.message')}</span>
      <Link className="feedback-invitation-banner__cta" to={FEEDBACK_PATH}>
        {t('feedbackInvitation.cta')}
      </Link>
      <button
        type="button"
        className="feedback-invitation-banner__dismiss"
        aria-label={t('feedbackInvitation.dismiss')}
        onClick={dismiss}
      >
        ×
      </button>
    </div>
  );
}

export default FeedbackInvitationBanner;
